import { AlertDialog, Button, Flex } from "@radix-ui/themes";

interface ExitEditDialogProps {
  open: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

function ExitEditDialog({ open, onCancel, onContinue }: ExitEditDialogProps) {
  return (
    <AlertDialog.Root open={open}>
      <AlertDialog.Content maxWidth="450px">
        <AlertDialog.Title>
          Are you sure you want to discard your changes?
        </AlertDialog.Title>
        <AlertDialog.Description size="2">
          This will discard your changes and restore the previous version.
        </AlertDialog.Description>

        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray" onClick={onCancel}>
              Cancel
            </Button>
          </AlertDialog.Cancel>

          <AlertDialog.Action>
            <Button
              variant="solid"
              color="gray"
              highContrast
              onClick={onContinue}
            >
              Discard Changes
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
}

export default ExitEditDialog;
